import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 2px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.5);
  transform: translate(0,52px);

  .camera-button {
    background-color: var(--primary-blue);
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 2px;
    transition: all 0.2s ease;
    z-index: 10005;
    img {
      width: 40px;
      height: 40px;
      color: var(--white);
      filter: invert(100%) sepia(100%) saturate(100%) brightness(200%) contrast(200%);
    }

    &:hover {
      background-color: var(--gray);
      transform: scale(1.05);
    }
  }
`;

export const WebcamContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #000;
  border-radius: 2px;
  overflow: hidden;

  .camera-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .close-button {
    position: absolute;
    top: 5px;
    right: 5px;
    /* z-index: 100; // Garante que fique acima do canvas */
    color: white;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    backdrop-filter: blur(2px);

    img {
      width: 12px;
      height: 12px;
      filter: invert(100%) sepia(100%) saturate(100%) brightness(100%) contrast(100%);
    }

    &:hover {
      background: rgba(255, 0, 0, 0.8);
      transform: scale(1.1);
    }
  }

  .result-badge {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgba(0, 128, 0, 0.85);
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    padding: 4px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    animation: slideUp 0.3s ease-out;
  }

  .ia-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 10px;
    background: rgba(0, 0, 0, 0.5);
    padding: 4px 8px;
    border-radius: 2px;
  }

  @keyframes slideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }
`;